/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown> }} Prescription_Exhausted_InjuryInputs */

const en_us2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The rest are filtered out by your ${i?.region} limitation.`)
};

const pt_br2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os demais foram filtrados pela sua limitação em ${i?.region}.`)
};

const es_419_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los demás quedaron filtrados por tu limitación en ${i?.region}.`)
};

const pt_pt2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os restantes foram filtrados pela tua limitação em ${i?.region}.`)
};

const fr_fr2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les autres sont écartés par ta limitation (${i?.region}).`)
};

const de_de2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die übrigen sind wegen deiner Einschränkung (${i?.region}) ausgefiltert.`)
};

const it_it2_prescription_exhausted_injury = /** @type {(inputs: Prescription_Exhausted_InjuryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gli altri sono esclusi per la tua limitazione (${i?.region}).`)
};

/**
* | output |
* | --- |
* | "The rest are filtered out by your {region} limitation." |
*
* @param {Prescription_Exhausted_InjuryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_exhausted_injury = /** @type {((inputs: Prescription_Exhausted_InjuryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Exhausted_InjuryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_exhausted_injury(inputs)
	if (locale === "es-419") return es_419_prescription_exhausted_injury(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_exhausted_injury(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_exhausted_injury(inputs)
	if (locale === "de-DE") return de_de2_prescription_exhausted_injury(inputs)
	if (locale === "it-IT") return it_it2_prescription_exhausted_injury(inputs)
	return en_us2_prescription_exhausted_injury(inputs)
});
export { prescription_exhausted_injury as "prescription.exhausted.injury" }